import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import logger from '../utils/logger';
import { API_ENDPOINTS, ROUTES } from '../utils/constants';

const BankSetupRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  const [isChecking, setIsChecking] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    const checkBankSetupAccess = async () => {
      if (loading || !user) {
        setIsChecking(false);
        return;
      }

      try {
        // Check KYC status
        const kycApproved = user.kycStatus === 'approved' || user.kycStatus === 'completed';
        
        // Fetch latest user profile to check bank account status
        const profileResponse = await api.get(API_ENDPOINTS.USER.PROFILE);
        const profile = profileResponse.data;
        
        // Check if bank account is successfully created
        const hasBankAccount = (profile.virtualAccountId || profile.bankAccountId) && 
          profile.bankDetails && 
          (profile.bankDetails.accountNumber || profile.bankDetails.iban);
        
        // Redirect if both conditions are met
        if (kycApproved && hasBankAccount) {
          setShouldRedirect(true);
        }
      } catch (error) {
        logger.errorWithStack('Failed to check bank setup access:', error);
        // On error, allow access (fail open)
      } finally {
        setIsChecking(false);
      }
    };

    checkBankSetupAccess();
  }, [user, loading]);

  if (loading || isChecking) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="text-center">
          <div className="inline-block w-8 h-8 border-[3px] border-primary-300/20 rounded-full border-t-primary-500 animate-spin shadow-[0_0_10px_rgba(102,126,234,0.3)] mb-4"></div>
          <p className="text-slate-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ROUTES.SIGNIN} replace />;
  }

  if (shouldRedirect) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return children;
};

export default BankSetupRoute;

